import WebsiteLaunchers from '../components/WebsiteLaunchers.jsx';
import Hero from '../components/Hero.jsx';
import Headers from '../components/Headers.jsx';
import StreamWestVideoPlayer from '../components/StreamWestVideoPlayer.jsx';
import { assets } from '../assets/assets.js';
import GitHubButton from '../components/GitHubLaunchRepo.jsx';
import Datascience from '../components/Datascience.jsx';
import CancerResearch from '../components/CancerResearch.jsx';

const Home = () => {
  return (
    <div>
      <Hero/>

      <div className='px-4 md:px-10 py-8'>
        <div id='projects'>
          <WebsiteLaunchers/>
        </div>
      </div>

      <Headers word1="Cell Cleanup / ML"/>
      <Datascience/>

      <Headers word1="Applications"/>
      <StreamWestVideoPlayer/>

      <div className='flex justify-center px-4 my-8'>
        <div className='bg-[#1a1a1a] border border-gray-700/60 rounded-2xl p-6 max-w-3xl w-full shadow-[0_0_20px_rgba(168,85,247,0.07)]'>
          <p className='text-xl font-bold mb-1 text-white'>Redaction Tool</p>
          <p className='text-gray-400 text-sm mb-4'>Document redaction tool — demo below</p>
          <div className='relative w-full rounded-xl overflow-hidden mb-4' style={{paddingTop: '56.25%'}}>
            <iframe
              className='absolute inset-0 w-full h-full rounded-xl'
              src="https://www.youtube.com/embed/5sd-HwG48DI?start=2"
              title="Redaction Tool Demo"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <GitHubButton link="https://github.com/walkmoody/RedactionTool"/>
        </div>
      </div>

      <div className='flex justify-center px-4 my-8'>
        <div className='bg-[#1a1a1a] border border-gray-700/60 rounded-2xl p-6 max-w-lg w-full shadow-[0_0_20px_rgba(56,189,248,0.07)]'>
          <p className='text-xl font-bold mb-1 text-white'>Python AutoClicker GUI</p>
          <p className='text-gray-400 text-sm mb-4'>Simple auto clicker utility built with Python and Tkinter</p>
          <img className='mb-4 rounded-xl w-full' src={assets.autoClicker} alt="Python GUI"/>
          <GitHubButton link="https://github.com/walkmoody/pythonClickBot"/>
        </div>
      </div>

      <Headers word1="Backends"/>

      <div className='flex justify-center px-4 my-8'>
        <div className='bg-[#1a1a1a] border border-gray-700/60 rounded-2xl p-6 w-full max-w-3xl shadow-[0_0_20px_rgba(168,85,247,0.07)]'>
          <p className='text-xl font-bold mb-1 text-white'>StreamWest Backend</p>
          <p className='text-gray-400 text-sm mb-6'>Express/Node.js API with MongoDB. Handles video upload, streaming, and user auth.</p>
          <div className='flex flex-col gap-4'>
            <div>
              <p className='text-xs text-gray-500 mb-1'>Video Upload Schema</p>
              <img className='rounded-xl w-full' src={assets.videoSchema} alt="Schema"/>
            </div>
            <div>
              <p className='text-xs text-gray-500 mb-1'>MongoDB Collections</p>
              <img className='rounded-xl w-full' src={assets.streamWestDB} alt="MongoDB"/>
            </div>
            <div>
              <p className='text-xs text-gray-500 mb-1'>Backend Routes</p>
              <img className='rounded-xl w-full' src={assets.backendRoutes} alt="Routes"/>
            </div>
          </div>
        </div>
      </div>

      <div className='flex justify-center px-4 my-8'>
        <div className='bg-[#1a1a1a] border border-gray-700/60 rounded-2xl p-6 w-full max-w-3xl shadow-[0_0_20px_rgba(56,189,248,0.07)]'>
          <p className='text-xl font-bold mb-1 text-white'>Ecommerce Backend</p>
          <p className='text-gray-400 text-sm mb-6'>Node.js/Express REST API with MongoDB for the full-stack clothing store.</p>
          <div className='flex flex-col gap-4'>
            <div>
              <p className='text-xs text-gray-500 mb-1'>Order Placement</p>
              <img className='rounded-xl w-full' src={assets.Orders} alt="Orders"/>
            </div>
            <div>
              <p className='text-xs text-gray-500 mb-1'>User Creation / Login</p>
              <img className='rounded-xl w-full' src={assets.Users} alt="Users"/>
            </div>
            <div>
              <p className='text-xs text-gray-500 mb-1'>Product Schema</p>
              <img className='rounded-xl w-full' src={assets.Products} alt="Products"/>
            </div>
            <div>
              <p className='text-xs text-gray-500 mb-1'>Server &amp; Routes</p>
              <img className='rounded-xl w-full' src={assets.BackendEcom} alt="Backend"/>
            </div>
          </div>
          <div className='mt-4'>
            <GitHubButton link="https://github.com/walkmoody/Ecommerce-Clothing-Website"/>
          </div>
        </div>
      </div>

      <Headers word1="Lung Cancer Research"/>
      <CancerResearch/>

      <div className='py-16'/>
    </div>
  )
}

export default Home
